import { ProductVirtualSkuRouteService } from 'common/data';
import { BaseService } from 'core/services';
import { findParams } from 'core/utils';
import _ from 'lodash';

class ProductVirtualSkuService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new ProductVirtualSkuRouteService());
	}

	find(filter) {
		var url = this.routeService.find(filter);
		return this.apiClient.post(url, findParams(filter));
	}
}

export default ProductVirtualSkuService;



// WEBPACK FOOTER //
// ./src/common/data/services/ProductVirtualSkuService.js